// src/views/bots/questions/LocationQuestion.tsx
// 🎨 LOCATION QUESTION - GPS/location sharing for WhatsApp
// ✅ UPDATED: Major cleanup - removed fake location options, preview, and false claims

import React from 'react';
import BaseQuestion from './BaseQuestion';
import styles from './Questions.module.css';
import { QuestionItem } from '../hooks/useBotForm';
import logger from '../../../utils/logger';

interface LocationQuestionProps {
  question: QuestionItem;
  index: number;
  onUpdate: (id: string, field: keyof QuestionItem, value: any) => void;
  onRemove: (id: string) => void;
  onMoveUp: () => void;
  onMoveDown: () => void;
  canMoveUp: boolean;
  canMoveDown: boolean;
  forceCollapsed?: boolean;
}

const LocationQuestion: React.FC<LocationQuestionProps> = (props) => {
  const { question } = props;
  
  logger.log('📍 LocationQuestion: Rendering simplified location question:', question.id);

  return (
    <BaseQuestion {...props}>
      
      {/* ❌ REMOVED: typeSpecificOptions section with fake location sharing options */}
      {/* ❌ REMOVED: locationPreview section with fake sample location */}
      {/* ❌ REMOVED: locationInfo section with fake location sharing features */}
      {/* ❌ REMOVED: whatsappInfo section with fake WhatsApp location features */}
      {/* ❌ REMOVED: useCasesInfo section */}

      {/* 🎯 SIMPLE LOCATION QUESTION PREVIEW */}
      <div className={styles.questionPreview}>
        <div className={styles.previewLabel}>Preview:</div>
        <div className={styles.previewContent}>
          <div className={styles.previewQuestion}>
            {question.question || 'Enter your question above...'}
            {question.required && <span className={styles.requiredAsterisk}>*</span>}
          </div>
          <div className={styles.previewInput}>
            <div style={{
              padding: '12px',
              border: '1px solid #d1d5db',
              borderRadius: '6px',
              background: '#f9fafb',
              color: '#6b7280',
              fontSize: '14px',
              textAlign: 'center'
            }}>
              📍 Location sharing will be available in WhatsApp
            </div>
          </div>
        </div>
      </div>
      
    </BaseQuestion>
  );
};

export default LocationQuestion;